import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import BreastCancerLandingPage from './BreastCancerLandingPage';
import RiskAssessment from './components/RiskAssessment';
import Dashboard from './components/Dashboard';
import StripAnalyzer from "./components/StripAnalyzer";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<BreastCancerLandingPage />} />
            <Route path="/risk-assessment" element={<RiskAssessment />} />
            <Route path="/dashboard" element={<Dashboard />} />
           <Route path="/strip-analyzer" element={<StripAnalyzer />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
